module.exports = __webpack_public_path__ + "static/media/team_1.2811896e.jpg";